import script from "./PerformanceTrendChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceTrendChart.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceTrendChart.vue?vue&type=style&index=0&id=86035eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86035eb0"]])

export default __exports__